
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import ContactInfo from './components/ContactInfo';
import InquiryForm from './components/InquiryForm';
import QuickLinks from './components/QuickLinks';
import MapSection from './components/MapSection';

export default function ContactPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Greenfield Partners",
    "description":
      "Get in touch with Greenfield Partners for precision drone services, aerial application, and land management inquiries across the Mid-Atlantic region.",
    "url": `${siteUrl}/contact`,
    "mainEntity": {
      "@type": "Organization",
      "name": "Greenfield Partners",
      "telephone": "+1-717-913-1780",
      "email": "info@greenfieldpartners.com",
      "areaServed": [
        { "@type": "State", "name": "Pennsylvania" },
        { "@type": "State", "name": "Maryland" },
        { "@type": "State", "name": "Delaware" },
        { "@type": "State", "name": "Virginia" },
        { "@type": "State", "name": "West Virginia" }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Contact Greenfield Partners | Precision Drone Services Mid-Atlantic"
        description="Reach out to Greenfield Partners for precision aerial application, deer deterrent, timber forestry, and land management services. Serving PA, MD, DE, VA, WV. Response within 24 hours."
        keywords="contact Greenfield Partners, drone services inquiry, aerial application quote, Mid-Atlantic drone services, precision agriculture contact"
        schema={schema}
      />
      <Header />

      <main>
        <HeroSection />

        {/* Main Form + Info Section */}
        <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-[380px_1fr] gap-10">
              <ContactInfo />
              <InquiryForm />
            </div>
          </div>
        </section>

        <MapSection />
        <QuickLinks />
      </main>

      <Footer />
    </div>
  );
}
